export const EMAIL_PATTERN_SIMPLE = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';
export const EMAIL_PATTERN =
  "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$";

export const STREET_PATTERN = '^([\\wäÄöÖüÜß\\.]+[\\s-]+)+\\d+\\w*$';

export const ZIP_PATTERN = '^[0-9]{4,5}$';
